import React, { useState, useCallback, useMemo } from "react";
import Select from "react-select";
import debounce from "lodash.debounce";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import "./FilterSelector.css";
import DatePickerMulti from "react-multi-date-picker";
import { mergeAndFormatOptions } from "../../../../utils/constants";

const isArray = (arr) => Array.isArray(arr);

const FilterRow = ({
  index,
  selected,
  onChangeField,
  onChangeValue,
  onRemoveRow,
  canRemove,
  allKeyOptions,
  valueOptions,
  fetchValues,
  handleDateChange,
  loadingValues,
  columnMetadata,
}) => {
  const hasField = selected && selected.field;

  const handleChangeInput = (event, type) => {
    const { value } = event.target;
    onChangeValue(index, { ...selected.value, [type]: value });
  };

  const finalValues = mergeAndFormatOptions(allKeyOptions).filter(
    (field) => field && field.isActive !== false
  );
  
  

  const permanentOptions = useMemo(() => {
    return selected.field &&
      columnMetadata &&
      columnMetadata[selected.field.value]
      ? columnMetadata[selected.field.value].map((one) => ({
          label: one,
          value: one,
        }))
      : [];
  }, [selected.field, columnMetadata]);


  console.log('50 - valueOpt options : ', JSON.stringify(permanentOptions))


  console.log('54 - perm options : ', JSON.stringify(permanentOptions))

  const allValueOptions = useMemo(() => {

    const combined = selected.field && valueOptions[index] &&permanentOptions
      ? [...valueOptions[index], ...permanentOptions]
      : valueOptions[index];


      console.log('50 - perm options : ', JSON.stringify(permanentOptions))


    const seen = new Set();
    const deduplicated = combined ?  combined.filter((option) => {
      if (seen.has(option.value)) return false;
      seen.add(option.value);
      return true;
    }) : [];

    return deduplicated;
  }, [selected.field, valueOptions, index, permanentOptions]);


  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "15px",
        marginTop: index === 0 ? "10px" : "5px",
        width: "100%",
      }}
    >
      <p style={{ fontSize: "16px", fontWeight: "500", width: "75px" }}>
        Filter
      </p>

      <Select
        name={`field-selector-${index}`}
        placeholder="Select field"
        value={hasField}
        onChange={(val) => onChangeField(index, val)}
        options={finalValues}
        clearable
        className="custom-select-dropdown"
      />

      <p></p>

      {selected.isValidFormat && selected.isActive ? (
        <DatePickerMulti
          name={`value-selector-${index}`}
          value={selected.value}
          onChange={(val) => handleDateChange(index, val)}
          range
          style={{ height: "40px", width: "100%" }}
          format="MM/DD/YYYY"
          placeholder="Select Date Range"
          arrow
        />
      ) : selected.type === "number" ? (
        <>
          <input
            type="number"
            placeholder="Start"
            value={selected.value.start || ""}
            onChange={(e) => handleChangeInput(e, "start")}
            style={{
              height: "40px",
              width: "100px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
          <input
            type="number"
            placeholder="End"
            value={selected.value.end || ""}
            onChange={(e) => handleChangeInput(e, "end")}
            style={{
              height: "40px",
              width: "100px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </>
      ) : (
        <Select
          name={`value-selector-${index}`}
          placeholder="Search value"
          isDisabled={hasField === null || loadingValues[index]}
          isLoading={loadingValues[index]}
          onSelectResetsInput={
            (Array.isArray(selected.value) ? selected.value.length : 0) > 0
          }
          value={Array.isArray(selected.value) ? selected.value : []}
          onChange={(val) => {
            const valArray = Array.isArray(val) ? val : [val];
            onChangeValue(index, valArray);
          }}
          onInputChange={(val) => {
            if (val) fetchValues(val, index);
            return val;
          }}
          options={allValueOptions}
          multi
          clearable
          className="custom-select-dropdown"
        />
      )}

      <button
        onClick={() => onRemoveRow(index)}
        style={{
          backgroundColor: "#dc3545",
          color: "#fff",
          border: "none",
          padding: "6px 12px",
          borderRadius: "8px",
          cursor: canRemove ? "pointer" : "not-allowed",
          opacity: canRemove ? 1 : 0.5,
        }}
        disabled={!canRemove}
      >
        remove
      </button>
    </div>
  );
};

const FilterSelector = ({ allMetaData, trivvyType, shareType, handleApplyFilters }) => {
  const [filters, setFilters] = useState([
    {
      field: null,
      value: {},
      isValidFormat: false,
      isActive: false,
      type: "string",
    },
  ]);
  const [valueOptions, setValueOptions] = useState([[]]);
  const [loadingValues, setLoadingValues] = useState([false]);

  const typeInfo = isArray(allMetaData && allMetaData.typeInfo)
    ? allMetaData.typeInfo
    : [];

  const allKeyOptions = useMemo(() => {
    return typeInfo
      
      .map((field) => ({
        label: field.fieldName,
        value: field.fieldName,
        isValidFormat: field.isValidFormat,
        isActive: field.isActive,
        type: field.type,
      }));
  }, [typeInfo]);

  const fetchValues = useCallback(
    debounce((input, index) => {
      const selectedKey =
        filters[index] && filters[index].field && filters[index].field.value;

      if (!selectedKey) return;

      const loading = [...loadingValues];
      loading[index] = true;
      setLoadingValues(loading);

      console.log('219-----', trivvyType)

      axios
        .get(url.searchUsersByMetaData, {
          params: {
            term: input,
            type: "user",
            key: selectedKey,
            trivvyType,
            shareType
          },
        })
        .then(({ data }) => {
          const options =
            data && data.results
              ? data.results.map((item) => ({
                  label: item.value,
                  value: item.value,
                }))
              : [];

          const updated = [...valueOptions];
          updated[index] = options;
          setValueOptions(updated);
        })
        .catch(() => {
          const fallback = [...valueOptions];
          fallback[index] = [];
          setValueOptions(fallback);
        })
        .finally(() => {
          const done = [...loadingValues];
          done[index] = false;
          setLoadingValues(done);
        });
    }, 300),
    [filters, valueOptions, loadingValues]
  );

  const handleChangeField = useCallback(
    (index, val) => {
      
      const updated = [...filters];
      updated[index] = {
        ...updated[index],
        field: val,
        value: {},
        isValidFormat:
          (allKeyOptions.find((opt) => opt.value === val.value) &&
            allKeyOptions.find((opt) => opt.value === val.value)
              .isValidFormat) ||
          false,
        isActive:
          (allKeyOptions.find((opt) => opt.value === val.value) &&
            allKeyOptions.find((opt) => opt.value === val.value).isActive) ||
          false,
        type:
          (allKeyOptions.find((opt) => opt.value === val.value) &&
            allKeyOptions.find((opt) => opt.value === val.value).type) ||
          "string",
      };
      
      setFilters(updated);

      const newValueOptions = [...valueOptions];
      newValueOptions[index] = [];
      
      setValueOptions(newValueOptions);
    },
    [filters, allKeyOptions, valueOptions]
  );

  const handleChangeValue = useCallback(
    (index, val) => {
      const updated = [...filters];
      updated[index].value = val;
      setFilters(updated);
    },
    [filters]
  );

  const handleAddRow = useCallback(() => {
    setFilters([
      ...filters,
      {
        field: null,
        value: {},
        isValidFormat: false,
        isActive: false,
        type: "string",
      },
    ]);
    setValueOptions([...valueOptions, []]);
    setLoadingValues([...loadingValues, false]);
  }, [filters, valueOptions, loadingValues]);

  const handleRemoveRow = useCallback(
    (index) => {
      if (filters.length === 1) return;
      setFilters(filters.filter((_, i) => i !== index));
      setValueOptions(valueOptions.filter((_, i) => i !== index));
      setLoadingValues(loadingValues.filter((_, i) => i !== index));
    },
    [filters, valueOptions, loadingValues]
  );

  const buildFilterQuery = useCallback((filters) => {
    const params = new URLSearchParams();
    filters.forEach((filter) => {
      const key = filter && filter.field && filter.field.value;
      const values = filter && filter.value;
      if (key && values) {
        if (filter.type === "number") {
          if (values.start !== undefined && values.start !== "") {
            params.append(`filters[${key}][start]`, values.start);
          }
          if (values.end !== undefined && values.end !== "") {
            params.append(`filters[${key}][end]`, values.end);
          }
        } else if (filter.type === "date") {
          values.forEach((v) => {
            if (v && v instanceof Date) {
              params.append(`filters[${key}]`, v.toISOString());
            }
          });
        } else {
          values.forEach((v) => {
            params.append(`filters[${key}]`, v.value || v);
          });
        }
      }
    });
    return params.toString();
  }, []);

  const handleApply = useCallback(() => {
    const query = buildFilterQuery(filters);
    handleApplyFilters(encodeURIComponent(query));
  }, [filters, buildFilterQuery, handleApplyFilters]);

  const isApplyDisabled = useMemo(() => {
    return !filters.some(
      (f) =>
        f &&
        f.field &&
        f.value &&
        (f.type === "number"
          ? f.value.start !== "" || f.value.end !== ""
          : f.value.length > 0)
    );
  }, [filters]);

  const handleDateChange = useCallback(
    (index, val) => {
      const updated = [...filters];
      updated[index].value = val.map((date) => new Date(date));
      setFilters(updated);
    },
    [filters]
  );

  return (
    <>
      {filters.map((selected, index) => (
        <FilterRow
          key={index}
          index={index}
          selected={selected}
          onChangeField={handleChangeField}
          onChangeValue={handleChangeValue}
          onRemoveRow={handleRemoveRow}
          canRemove={filters.length > 1}
          allKeyOptions={allKeyOptions}
          valueOptions={valueOptions}
          fetchValues={fetchValues}
          loadingValues={loadingValues}
          handleDateChange={handleDateChange}
          columnMetadata={allMetaData && allMetaData.columnMetadata}
        />
      ))}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
        }}
      >
        <button
          onClick={handleAddRow}
          style={{
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            padding: "6px 12px",
            borderRadius: "8px",
            cursor: "pointer",
            width: "80px",
          }}
        >
          And
        </button>
        <button
          onClick={handleApply}
          disabled={isApplyDisabled}
          style={{
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            padding: "6px 12px",
            borderRadius: "8px",
            cursor: "pointer",
            width: "80px",
            opacity: isApplyDisabled ? "0.5" : "1",
          }}
        >
          Apply
        </button>
      </div>
    </>
  );
};

export default FilterSelector;
